import React from 'react';
import { Badge } from '@/components/ui/badge';

const SEVERITY_STYLES = {
  minor: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300',
  moderate: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950 dark:text-orange-300',
  major: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300',
};

const STATUS_STYLES = {
  pending: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300',
  acknowledged: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300',
  deducted: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300',
  waived: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950 dark:text-purple-300',
};

export const SeverityBadge = ({ severity }) => (
  <Badge variant="outline" className={`text-xs capitalize ${SEVERITY_STYLES[severity] || SEVERITY_STYLES.minor}`}>
    {severity || 'minor'}
  </Badge>
);

export const StatusBadge = ({ status }) => (
  <Badge variant="outline" className={`text-xs capitalize ${STATUS_STYLES[status] || STATUS_STYLES.pending}`}>
    {status || 'pending'}
  </Badge>
);

export const SourceBadge = ({ source }) => (
  <Badge variant="outline" className="text-[10px]">
    {source === 'zoho_form' ? 'Zoho Form' : 'Manual'}
  </Badge>
);
